import styled from '@emotion/styled'

export const Header = styled.div`
  display: flex;
  gap: 25px;
  width: 100%;
  align-items: center;
`
